/**
 * 获取制定数量的随机数
 * @param len 生成的随机数字符串长度
 * @returns 随机数串
 */
function getRandomNumStr(len: number) {
  let str = '';
  while (str.length < len) {
    const newNum = Math.floor(Math.random() * 10).toString();
    str += newNum;
  }
  return str;
}

/**
 * 10位（第一位是1）第一位作为采样位，置为8|9表示模调采样，9预留给应用打印debug
 * @return {[type]} [description]
 */
function generateTimestamp() {
  const timestampStr = Math.floor(new Date().getTime() / 1000)
    .toString()
    .slice(-9);
  return `8${timestampStr}`;
}

/** 生成随机数 */
export function generateMsgNo() {
  const ip = getRandomNumStr(8); // 8位，16进制IP
  const timestamp = generateTimestamp();
  const pidOrTid = getRandomNumStr(5); // PID或者TID严格控制，推荐用5位
  const sequenceNo = getRandomNumStr(5);
  const guid = `555${ip}${timestamp}${pidOrTid}${sequenceNo}`;
  return guid;
}
